const ListOfPaymentsTable = {
  columns: {
    getColumnsData: 'listOfPaymentsColumnsData',
    setColumnsData: 'setListOfPaymentsColumnsData'
  },
  rows: {
    getRowsData: 'listOfPaymentsRowsData',
    setRowsData: 'setListOfPaymentsRowsData'
  }
}

const ListOfPaymentsTableColumns = [
  {
    id: 0,
    title: 'User',
    property: 'user.username',
    capitalize: true
  },
  {
    id: 1,
    title: 'Customer',
    property: 'customer.nickName',
    route: 'customer.id',
    nameRoute: 'ContactCard',
    capitalize: true,
    hover: true
  },
  {
    id: 2,
    title: 'Proforma No.',
    property: 'invoice.number'
  },
  {
    id: 3,
    title: 'Total Invoiced, AED',
    property: 'invoice.totalInvoicedAed'
  },
  {
    id: 4,
    title: 'Received , AED',
    inputs: ['amountReceived'],
    editable: true,
    actions: {
      edit: true,
      delete: true
    },
    typeEditable: 'inputNumber',
    property: 'amountReceived'
  },
  {
    id: 5,
    title: 'Payment Date',
    type: 'date',
    property: 'paymentDate'
  },
/*  {
    id: 6,
    title: 'Tax Inv No',
    inputs: ['taxInvNo'],
    editable: true,
    actions: {
      edit: true,
      delete: true
    },
    typeEditable: 'inputString',
    property: 'taxInvNo'
  },*/
  {
    id: 6,
    title: 'Tax Inv No',
    property: 'invoice.taxInvoiceNumber'
  },
  {
    id: 7,
    property: 'action',
    inputs: ['amountReceived'],
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false
    }
  },
]

export {ListOfPaymentsTable, ListOfPaymentsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/ListOfPaymentsTable.js